import { createEffect, createStore } from 'effector';
import api from '../Auth/api';

export const $clientSearch = createStore([]);

export const searchClientFx = createEffect(
  async (query) => {
    if (query) {
      const response = await api.post(`/client/search`, { query });
      return response;
    }
  }
);

$clientSearch.on(searchClientFx, (_) => {
  return [];
});

$clientSearch.on(searchClientFx.done, (_, { result }) => {
  if (result?.data?.data) {
    return [...result.data.data];
  }
});

$clientSearch.on(searchClientFx.fail, () => {
  return [];
});